import React from "react";
import line from "../assets/line.png";

const Innovation = () => {
  const steps = [
    "To pioneer AI-driven innovation that transforms industries, enhances decision-making, and empowers businesses with intelligent, scalable, and future-ready solutions",
    "To pioneer AI-driven innovation that transforms industries, enhances decision-making, and empowers businesses with intelligent, scalable, and future-ready solutions",
    "To pioneer AI-driven innovation that transforms industries, enhances decision-making, and empowers businesses with intelligent, scalable, and future-ready solutions",
    "To pioneer AI-driven innovation that transforms industries, enhances decision-making, and empowers businesses with intelligent, scalable, and future-ready solutions",
    "To pioneer AI-driven innovation that transforms industries, enhances decision-making, and empowers businesses with intelligent, scalable, and future-ready solutions",
    "To pioneer AI-driven innovation that transforms industries, enhances decision-making, and empowers businesses with intelligent, scalable, and future-ready solutions",
  ];

  return (
  <section className="w-full flex justify-center bg-white px-4 py-10">
  <div className="max-w-6xl w-full">
    {/* Heading */}
    <h2 className="text-2xl md:text-3xl font-semibold mb-6">
      <div className="relative inline-block pb-2">
        <span className="relative z-10">
          <span className="text-[#00cfff]">Our</span>{" "}
          <span className="text-black">Path to Innovation</span>
        </span>
        <img
          src={line}
          alt="underline"
          className="absolute left-0 bottom-0 h-[8px] w-full object-contain"
        />
      </div>
    </h2>

    {/* Timeline container */}
    <div className="relative">
      {/* Vertical dashed line */}
     <div
  className="absolute left-5 top-0 bottom-0 w-px border-l-2 border-dashed"
  style={{ borderColor: "#7B61FF", height: 'auto' }}
/>

      {/* Timeline items */}
      <div className="flex flex-col gap-5">
        {steps.map((text, index) => (
          <div key={index} className="flex items-start gap-5">
            {/* Circle */}
            <div className="relative w-10 flex justify-center pt-1">
              <div className="w-10 h-10 rounded-full border-2 border-[#7B61FF] bg-white z-10" />
            </div>

            {/* Text */}
            <p className="text-gray-800 font-calibri text-[15px] md:text-[17px] leading-relaxed">
              {text}
            </p>
          </div>
        ))}
      </div>
    </div>
  </div>
</section>

  );
};

export default Innovation;
